import { SxProps, Theme } from '@mui/material';

export const DpCatalogEntryCarouselHeaderContentSX = (buttons: number): SxProps => ({
	display: 'flex',
	flexDirection: {
		xs: 'column',
		sm: 'row',
	},
	gap: '10px',
	alignItems: {
		sm: 'center',
	},
	mb: { xs: buttons > 0 ? '10px' : '20px', sm: '20px' },
});

export const DpCatalogEntryCarouselHeaderTitleSX = (isHref: boolean): SxProps<Theme> => ({
	textTransform: 'uppercase',
	mb: { xs: '0px', sm: '0' },
	cursor: isHref ? 'pointer' : 'default',
});

export const DpCatalogEntryCarouselHeaderButtonsFrameSX: SxProps = {
	display: 'inline-flex',
	overflow: 'auto',
	marginTop: { xs: '5px', sm: '0px' },
	rowGap: '10px',
	columnGap: '10px',
	whiteSpace: 'nowrap',
	paddingBottom: { xs: '10px', sm: 0 },
	width: { xs: '100%', sm: 'auto' },
	maxWidth: { xs: '100%', sm: 'auto' },
};

export const DpCatalogEntryCarouselHeaderButtonSX = (selected: boolean): SxProps => ({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	padding: '11px 14px 12px 14px',
	textAlign: 'center',
	backgroundColor: selected ? '#333333' : '#F7F7F8',
	border: selected ? '1px solid #333333' : '1px solid #CBCACC',
	borderRadius: '21px',
	cursor: 'pointer',
	fontSize: { xs: 'var(--font-size-default)', sm: 'var(--font-size-body)' },
	fontWeight: selected ? 'bold' : 'normal',
	color: selected ? '#FFFFFF' : '#333333',
	height: '44px',
	'&:hover': {
		backgroundColor: '#333333',
		color: '#FFFFFF',
		fontWeight: 'bold',
		border: '1px solid #333333',
	},
});
